import { createAction } from 'redux-actions';

export const toggleSidebarNav = createAction('TOGGLE_RESERVATION_SIDEBAR_NAV');
